class ReactFormatterLettersStatusWithIconFormat extends React.Component {

    constructor(props) {
        super(props);
        
        this._icons = {
            'preupload': (
                <span className="status-icon preupload">
                <i className="fa fa-upload" aria-hidden="true"/>
            </span>
            ),
            'upload': (
                <span className="status-icon upload">
                <i className="fa fa-cloud-upload" aria-hidden="true"/>
            </span>
            ),
            'review': (
                <span className="status-icon review">
                <i className="fa fa-search" aria-hidden="true"/>
            </span>
            ),
            'accepted': (
                <span className="status-icon accepted">
                <i className="fa fa-thumbs-up" aria-hidden="true"/>
            </span>
            ),
            'rejected': (
                <span className="status-icon rejected">
                <i className="fa fa-thumbs-down" aria-hidden="true"/>
            </span>
            ),
            'delivered': (
                <span className="status-icon delivered">
                <i className="fa fa-paper-plane" aria-hidden="true"/>
            </span>
            ),
            'read': (
                <span className="status-icon read">
                <i className="fa fa-eye" aria-hidden="true"/>
            </span>
            ),
        };
    }


    render() {
        return (
            <span className="status-cell">
                {this._icons[this.props.value]}
                <span>{_.capitalize(this.props.value)}</span>
            </span>
        )
    }
}

ReactFormatterLettersStatusWithIconFormat.defaultProps = {};